<template>
  <!-- 续年度服务津贴 -->
  <div>
    <Modal v-model="visible" width="1200px" title="续年度服务津贴(%)" :footer-hide="true" :mask-closable="false" class="my-modal">
      <div class="tools-box">
        <Button type="primary" @click="addIndex(indexList)" v-if="indexList.length == 0">新增</Button>
      </div>
      <div class="table">
        <div class="tr">
          <div class="td th big-td">方案</div>
          <div class="td th" v-for="head in headList" :key="head.id">{{ head.name }}</div>
          <div
            class="td th big-td"
            v-for="(bean, i) in indexList"
            :key="bean.key"
            :id="'key' + bean.key"
            :class="{ 'last-td': i == indexList.length - 1 && bean.id }"
          >
            <Select v-model="bean.id" style="width: 100px" @on-change="selectChange(i)">
              <Option v-for="iBean in allIndexList" :key="iBean.id" :value="iBean.id" :disabled="disabledOpt(iBean.id)">{{ iBean.name }} </Option>
            </Select>
            <Checkbox v-if="i == indexList.length - 1 && bean.id" v-model="payPeriodFull" true-value="1" false-value="0">至交费期满</Checkbox>
            <Icon type="md-close-circle" color="#F26868" size="24" @click="del(indexList, i)" />
            <Icon type="md-add-circle" color="#236DFF" size="24" @click="addIndex(indexList)" v-if="i == indexList.length - 1 && payPeriodFull != 1" />
          </div>
        </div>
        <div class="tr" v-for="row in list" :key="row.key">
          <div class="td big-td">{{ row.name }}</div>
          <div class="td" v-for="head in headList" :key="head.key">{{ row[head.code] || '-' }}</div>
          <div
            class="td big-td"
            v-for="(row2, i) in row.renewCommissionList"
            :key="row2.key"
            :class="{ 'last-td': i == indexList.length - 1 && row2.commissionIndex }"
          >
            <Input
              v-model="row2.commission"
              placeholder="请输入"
              class="table-input"
              :class="{ 'red-bor': row2.commissionError }"
              @input="inputChange(row2, $event)"
            >
              <span slot="append">%</span>
            </Input>
          </div>
        </div>
      </div>
      <div class="ivu-modal-footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="submit" :loading="loading">确定</Button>
      </div>
    </Modal>
    <!-- 确认弹窗 -->
    <confirm-modal ref="confirmModal"></confirm-modal>
  </div>
</template>
  
<script>
import confirmModal from '@/components/commons/confirmModal';
import serviceAllowance from './serviceAllowance.config.js';
import common from './common.config.js';
export default {
  mixins: [serviceAllowance, common],
  components: { confirmModal },
  props: {
    curSupplier: null
  },
  data() {
    return {
      visible: false,
      loading: false,
      over: true,
      tableItem: {},
      topItem: {}
    };
  },
  computed: {},
  created() {},
  methods: {
    async open(e) {
      this.tableItem = e.tableItem;
      this.topItem = e.topItem;
      if (this.topItem.sourceType != 2) {
        return;
      }
      const status = await this.getStatus();
      if (status) {
        this.initData(true);
      } else {
        this.openBaseModal();
      }
    },
    // 选择年限
    selectChange(i) {
      const id = this.indexList[i].id;
      this.list.forEach(item => {
        this.$set(item.renewCommissionList[i], 'commissionIndex', id);
      });
      this.$nextTick(() => {
        document.getElementById('key' + this.indexList[i].key).scrollIntoView();
      });
    },
    // 新增费用行
    addIndex(list) {
      const last = list[list.length - 1];
      if (last && !last.id) {
        this.$notice.msg('请先配置续年度');
        return;
      }
      const key = Date.now();
      list.push({ key: 'i' + key });
      this.list.forEach(item => {
        item.renewCommissionList.push({ key: 'i' + key, commission: '' });
      });
      this.$nextTick(() => {
        document.getElementById('keyi' + key).scrollIntoView();
      });
    },
    del(list, i) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(() => {
          list.splice(i, 1);
          this.list.forEach(item => {
            item.renewCommissionList.splice(i, 1);
          });
        });
    },
    // 禁用选项
    disabledOpt(id) {
      return !!this.indexList.find(item => item.id == id);
    },
    cancel() {
      this.visible = false;
    },
    submit() {
      const last = this.indexList[this.indexList.length - 1];
      if (last) {
        if (!last.id) {
          this.$notice.msg('请先配置续年度');
          return;
        }
        const hasBig = this.indexList.find(item => item.id > last.id);
        if (hasBig && this.payPeriodFull == 1) {
          this.$notice.msg('续年度重复，请检查');
          return;
        }
      }
      let hasErr = false;
      const list = [];
      const params = {
        id: this.formData.id,
        productCode: this.topItem.productCode,
        isMain: this.tableItem.isMain,
        gradeCode: this.tableItem.gradeCode
      };
      this.list.forEach((item, i) => {
        item.renewCommissionList.forEach(item2 => {
          if (item2.commission === '') {
            hasErr = true;
            this.$set(item2, 'commissionError', true);
          } else {
            this.$set(item2, 'commissionError', false);
          }
          list.push({
            programId: item.programId,
            commissionIndex: item2.commissionIndex,
            commission: item2.commission,
            payPeriodFull: this.payPeriodFull
          });
        });
      });
      if (hasErr) {
        this.$notice.msg('请完善信息');
        return;
      }
      params.renewalCommissionDTOList = list;
      console.log(params);
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        url: '/buz/upcommission/configRenewalCommission',
        type: 'POST',
        data: params
      })
        .then(res => {
          this.$notice.msg('操作成功');
          this.$emit('reload');
          this.visible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.tools-box {
  margin-top: 15px;
}
.table {
  margin-right: 10px;
  margin-top: 30px;
  margin-bottom: 10px;
  max-width: 1150px;
  overflow-x: auto;
  .tr {
    .td {
      flex: 100px;
      min-width: 100px;
    }
    .big-td {
      flex: 150px;
      min-width: 150px;
    }
    .last-td {
      flex: 300px;
      min-width: 300px;
      justify-content: flex-start;
    }
  }
}
</style>  